import { Box } from "@mui/material";
import { motion, useReducedMotion } from "framer-motion";
import type { FC } from "react";
import { HALLOWEEN } from "@/theme/tokens";

/** One stable key per candy; the order also staggers their hops. */
const CANDY_KEYS = ["first", "second", "third"] as const;
const JUMP_PX = 10;
const JUMP_SECONDS = 1.1;
const STAGGER_SECONDS = 0.15;
const CANDY_ASPECT = 18 / 24;

/** Three candy corns hopping one after another. */
export const CandyCornLoader: FC<{ dataTestId?: string }> = ({ dataTestId }) => {
	const reduceMotion = useReducedMotion();
	return (
		<Box data-testid={dataTestId} aria-hidden sx={{ display: "flex", alignItems: "flex-end", gap: 1, pt: 1.25 }}>
			{CANDY_KEYS.map((candyKey, index) => (
				<motion.svg
					key={candyKey}
					width={HALLOWEEN.SIZE.CANDY_HEIGHT * CANDY_ASPECT}
					height={HALLOWEEN.SIZE.CANDY_HEIGHT}
					viewBox="0 0 18 24"
					animate={reduceMotion ? undefined : { y: [0, -JUMP_PX, 0, 0] }}
					transition={{ duration: JUMP_SECONDS, times: [0, 0.3, 0.6, 1], repeat: Number.POSITIVE_INFINITY, ease: "easeInOut", delay: index * STAGGER_SECONDS }}
				>
					<path d="M9 23 L1 3 Q9 -1 17 3 Z" fill={HALLOWEEN.CANDY_WHITE} stroke={HALLOWEEN.CANDY_OUTLINE} />
					<path d="M9 23 L4 10.5 L14 10.5 Z" fill={HALLOWEEN.CANDY_YELLOW} />
					<path d="M4 10.5 L2.2 6 Q9 3.2 15.8 6 L14 10.5 Z" fill={HALLOWEEN.PUMPKIN} />
				</motion.svg>
			))}
		</Box>
	);
};
